module.exports = __webpack_public_path__ + "assets/GoldNu2x.028591dab1a7cd62190ff8125a7ab086.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldNu2x.png
// module id = 815
// module chunks = 0